const redirectBtnContact = () => {
  const btnContact = document.querySelector(".btnContact button");
  if (!btnContact) return;

  const btnOpenMenu = document.querySelector(".open-nav");
  const contactLink = document.querySelector("[data-contact-trigger]");
  if (!contactLink) return;

  const openMenu = () => {
    btnOpenMenu?.click();
  };

  const clickContact = () => {
    contactLink.click();
  };

  btnContact.addEventListener("click", (e) => {
    e.preventDefault();
    setTimeout(openMenu, 500);
    setTimeout(clickContact, 1000);
  });
};

export const setPlayVideo = () => {
  const video = document.querySelector(".video-wrapper .video-banner");
  if (!video) return;

  video.autoplay = true;
  video.play();
};

export default redirectBtnContact;
